import React from 'react';
import List from '../../components/attractions/List';
import Map from '../../components/map/Map';

import Loading from '../../components/Loading';

import { gsap } from "gsap/all";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { getAttractions, getCoursesSimple, getCourseAttractions } from '../../../utils/cms';

class App extends React.Component {
	constructor(props){
    super(props);
		this.state = {
			attractions: null,
			attractionsLoaded: false,
			displayMode: 'list',
			courses: [],
			course: '',
			status: '',
			theme: ''
		};

		this.isMedieval = ['medievalCityNo', 'medievalCityEn'].includes(props.currentSiteHandle);

		this.changeDisplayMode = this.changeDisplayMode.bind(this);
		this.onChangeCourse = this.onChangeCourse.bind(this);
		this.onChange = this.onChange.bind(this);
		this.getAttractions = this.getAttractions.bind(this);
		this.getCourseAttractions = this.getCourseAttractions.bind(this);
		// this.getDropdownData = this.getDropdownData.bind(this);

		this.tabButtons = document.body.querySelectorAll('.tab-button');

		this.dropdown = document.body.querySelector('#select-course');
		this.themesDropdown = document.body.querySelector('#select-theme');
		this.statusDropdown = document.body.querySelector('#select-status');
  }

	async componentDidMount () {
		this.getAttractions();
		// this.getDropdownData();

		this.parallax();

		if (this.isMedieval) {
			// Something medieval
			this.themesDropdown.addEventListener('change', this.onChange);
			this.statusDropdown.addEventListener('change', this.onChange);
		} else {
			// Kvadraturen
			this.dropdown.addEventListener('change', this.onChange);
		}

		this.tabButtons.forEach((item, i) => {
			item.addEventListener('click', this.changeDisplayMode);
		});
	}

	async onChange (e) {
		console.log({e});
		
		this.setState({[e.target.name]: e.target.value, attractions: null, attractionsLoaded: false});

		if (e.target.name === 'course') {
			this.onChangeCourse(e.target.value);
		} else {
			this.getAttractions();
		}
	}

	async getAttractions () {
		try {
			const { status, theme } = this.state;
			const attractions = await getAttractions(theme, status);

			console.log({getAttractions: attractions});
			this.setState({attractions: attractions.data, attractionsLoaded: true})
		} catch (e) {
			console.log({e});
			this.setState({attractionsLoaded: true})
		}
	}
	
	async getCourseAttractions (id) {
		try {
			const attractions = await getCourseAttractions(id);

			console.log({attractions});
			this.setState({attractions: attractions.data, attractionsLoaded: true})
		} catch (e) {
			console.log({e});
			this.setState({attractionsLoaded: true})
		}
	}

	async onChangeCourse (value) {
		if (value) {
			this.getCourseAttractions(value);
		} else {
			this.getAttractions();
		}
	}

	async changeDisplayMode (e) {
		await this.setState({displayMode: e.target.dataset.type});
		
		this.tabButtons.forEach((item, i) => {
			item.classList.remove('active');
			item.setAttribute('aria-selected', 'false');
		});
		e.target.classList.add('active');
		e.target.setAttribute('aria-selected', 'true');
	}

	parallax () {
		console.log('Parallax');

		ScrollTrigger.matchMedia({
			"(min-width: 200px)": function () {
				gsap.to('.illustration-map', {
					y: -60,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.page-title-container', {
					y: -100,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
				gsap.to('.intro-container', {
					y: -60,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
			},
			"(min-width: 768px)": function () {
				gsap.to('.illustration-map', {
					y: -300,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.page-title-container', {
					y: -100,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.filtering', {
					y: -80,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.intro-container', {
					y: -60,
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});

				gsap.to('.floating-elements', {
					y: 100 * Math.random(),
					x: 100 * Math.random(),
					scrollTrigger: {
				    trigger: '#attraction-container',
						start: 'top top',
						end: 'bottom top',
						scrub: 1,
					}
				});
			}
		});
	}

	render () {
		const { attractions, attractionsLoaded, displayMode } = this.state;

		if (attractions) {
				if (displayMode == 'list') {
					return <List attractions={attractions} isMedieval={this.isMedieval} />;
				} else {
					return (
						<section className="map-outer-container">
							<Map attractions={attractions} isMedieval={this.isMedieval} />
						</section>
					);
				}
		} else if (attractionsLoaded) {
			return null;
		} else {
			return <Loading />;
		}
	}
}
export default App;
